<template>
  <v-layout
    justify-left
    wrap>
    <v-flex md3>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h5 class="heading-4 mb-0">{{ 'krita.claims.availableclaims' | translate }}</h5>
        </div>
        <div class="v-card__text">
          <div>
            <span class="text-success">
              {{ claims.AvailableClaims | amount }}
            </span>
            <br >
            <span>
              {{ 'krita.claims.total' | translate }}
            </span>
          </div>
        </div>
      </div>
    </v-flex>
    <v-flex md3>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h4 class="heading-4 mb-0">{{ 'krita.claims.factoredclaims' | translate }}</h4>
        </div>
        <div class="v-card__text">
          <v-layout wrap>
            <v-flex md4>
              <span class="text-success">
                {{ claims.FactoredClaimsTotal | amount }}
              </span>
              <br >
              <span>
                {{ 'krita.claims.total' | translate }}
              </span>
            </v-flex>
            <v-flex md4>
              <span class="text-danger">
                {{ claims.FactoredClaimsOverdue | amount }}
              </span>
              <br >
              <span>
                {{ 'krita.claims.overdue' | translate }}
              </span>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
    <v-flex md3>
      <div 
        :class="disableApplicationLink ? 'v-card v-sheet theme--light': 'v-card v-sheet theme--light link'"

        @click="$emit('navigateToApplicationInProgress')">
        <div class="v-card__title v-card__title--primary">
          <h4 class="heading-4 mb-0">{{ 'krita.claims.applicationsinprogress' | translate }}</h4>
        </div>
        <div class="v-card__text">
          <v-layout wrap>
            <v-flex md12>
              <span
                :class="disableApplicationLink ? 'text-success' : 'text-success link'">
                {{ claims.ApplicationsInProgress | amount }}
              </span>
              <br >
              <span>
                {{ 'krita.claims.total' | translate }}
              </span>
              <v-icon 
                v-if="!disableApplicationLink" 
                class="icon">open_in_new</v-icon>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
    <!--<v-flex-->
    <!--md3-->
    <!--style="text-align: right">-->
    <!--<v-btn-->
    <!--id="show-modal"-->
    <!--class="mt-0"-->
    <!--color="#3357A0"-->
    <!--@click="showModal = true">{{ 'Get funding' | translate }}</v-btn>-->
    <!--&lt;!&ndash; use the modal component, pass in the prop &ndash;&gt;-->
    <!--<v-modal-->
    <!--v-if="showModal"-->
    <!--@close="showModal = false">-->
    <!--<transition name="modal">-->
    <!--<div-->
    <!--class="modal-mask"-->
    <!--style="text-align: left">-->
    <!--<div class="modal-wrapper">-->
    <!--<div class="modal-container">-->

    <!--<div class="modal-header">-->
    <!--<slot name="header">-->
    <!--{{ 'How much money to borrow?' | translate }}-->
    <!--</slot>-->
    <!--</div>-->

    <!--<div class="modal-body">-->
    <!--<slot name="body">-->
    <!--<input-->
    <!--v-model="message"-->
    <!--placeholder="200 000kr.">-->
    <!--</slot>-->
    <!--</div>-->

    <!--<div class="modal-footer">-->
    <!--<slot name="footer">-->
    <!--<span>-->
    <!--<v-btn color="primary">-->
    <!--{{ 'Send' | translate }}-->
    <!--</v-btn>-->
    <!--<v-btn-->
    <!--color="warning"-->
    <!--@click="$emit('close')">-->
    <!--{{ 'Close' | translate }}-->
    <!--</v-btn>-->
    <!--</span>-->
    <!--</slot>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</transition>-->
    <!--</v-modal>-->
    <!--</v-flex>-->
  </v-layout>
</template>

<script>
    export default {
        name: "ClaimsSummary",
        props: ['claims','disableApplicationLink']
    }
</script>

<style lang="css" scoped>
    .link {
        cursor:pointer;
    }
  .icon{
    float: right;
  }
</style>
